import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const steps = [{
  day: 'DÍA 1',
  label: 'Perfil'
}, {
  day: 'DÍA 7',
  label: 'Portfolio'
}, {
  day: 'DÍA 14',
  label: '$100'
}, {
  day: 'DÍA 21',
  label: '$300'
}, {
  day: 'DÍA 28',
  label: '$400+'
}, {
  day: 'DÍA 30',
  label: '$500✅'
}];
export function Roadmap() {
  return <div className="w-full py-8 overflow-x-auto" data-id="element-175">
      <div className="min-w-[600px] relative px-4" data-id="element-176">
        <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-700 -translate-y-1/2 z-0" data-id="element-177"></div>
        <div className="absolute top-1/2 left-0 w-4/5 h-1 bg-brand-green -translate-y-1/2 z-0" data-id="element-178"></div>

        <div className="relative z-10 flex justify-between" data-id="element-179">
          {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-180">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${i < 5 ? 'bg-brand-green text-black' : 'bg-gray-700 text-white'}`} data-id="element-181">
                {i < 5 ? <CheckCircle2Icon size={20} data-id="element-182" /> : <div className="w-3 h-3 rounded-full bg-white" data-id="element-183" />}
              </div>
              <div className="font-bold text-sm text-brand-green" data-id="element-184">
                {step.day}
              </div>
              <div className="text-xs text-gray-300" data-id="element-185">{step.label}</div>
            </div>)}
        </div>
      </div>
    </div>;
}